<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进宇飞" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              深圳市宇飞智能科技有限公司(简称“宇飞智慧通行”)成立于2015年。位于 深圳市龙华区观澜街道牛湖社区高尔夫大道89号G栋201。是一家专业从事智慧停车运 营、智慧出行系统平台的研发、销售与服务的企业。研发团队2010年开始从事停车场 管理系统的设计。经过10多年的积累，以全新的技术理念在使用云计算理念 设计出入管理系统，完全摆脱了传统系统的架构层次，前端设备直接上云，本地无电 脑、无局域网、无数据库、无软件。成功搭建了可承载200万+车场数、人行通道数据 并发量的统一云计算平台，涵盖了停车场管理系统、门禁门控系统、车位引导系统等。

              宇飞智慧通行设计的云计算人车出入管理系统，彻底的解决了电脑与局域网给 系统带来的巨大困扰，将售后服务成本降至最低。同时，也大大的降低了出入管理设 备的建设成本，管理成本。

              依托于云计算+物联网的设计架构，宇飞智慧通行建成了一套行人与车辆出入的全场景管理平台，含:停车场车牌识别管理系统、门禁门控管理系统，人行通道管理 系统和车位管理系统。以:“集中管理，云端应用”的全新理念，为大数据时代提供 全方位的城市级停车管理及运营服务。

              随着宇飞智慧出行将云计算应用于出入管理行业，标志着车禁门控系统行业告 别了电脑时代。迈进了一个更加便捷、更具有持续运营能力和服务能力的通道出入移 动管理时代。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.Content}}</p>
                        <p>{{courseOne.Year}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <!-- <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>我们只专注一件事情——工程项目管理</p>
          <span>确保工程无重大安全事故</span>
          <span>确保工程施工单位无大面积返工</span>
          <span>确保工程材料及设备无伪劣产品</span>
          <span>确保工程管理留下痕迹、实施过程可追溯</span>
        </div> -->
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                v-lazy="honor.Img"
                @click="dialogTableVisible = true ;dialogUrl = honor.Img;dialogTitle= honor.Remark"
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="team.Img">
                <p>{{team.name}}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <!-- <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img v-lazy="imgserver+partner.Img" alt />
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: false,
      honorList: [{Img:"https://web.wlyk.com/static/yufei_guonei/图片19.png",Remark:"公安部检查报告"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片20.png",Remark:"公安部检查报告"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片22.png",Remark:"注册商标"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片23.png",Remark:"无人值守软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片24.png",Remark:"视频对讲软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片25.png",Remark:"手机手表软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片26.png",Remark:"云计算平台软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/图片28.png",Remark:"城市停车软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu500.png",Remark:"城市停车软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu501.png",Remark:"城市停车软件著作权证书"},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu502.png",Remark:"城市停车软件著作权证书"}],
      partnerImg: [],
      courseList: [],
      teamItem: [{Img:"https://web.wlyk.com/static/yufei_guonei/tu503.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu504.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu505.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu506.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu507.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu508.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu509.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu510.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu511.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu512.jpg",name:""},
      {Img:"https://web.wlyk.com/static/yufei_guonei/tu513.jpg",name:""}
    ],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         // this.honorList = responseHonor.data;
    //         this.partnerImg = responseEnterprise.data;
    //        // this.teamItem = responseTeam.data;

    //         var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         window.console.log(groupCount);
    //         for (let i = 0; i < groupCount; i++) {
    //           let img2 = [];
    //           for (let j = 0; j < 2; j++) {
    //             if (responseCourse.data.length - 1 >= i * 2 + j) {
    //               img2.push(responseCourse.data[i * 2 + j]);
    //             }
    //           }
    //           console.log(img2)
    //           //this.courseList.push(img2);
    //         }
    //         this.loading = false;
    //       }
    //     )
    //   );
  },
  created(){
    let img2 = [{Content:"深圳宇飞智能科技有限公司成立",Year:"2015年7月"},
    {Content:"深圳宇飞智能科技有限公司拥有12名销售团队员工",Year:"2016年8月"},
    {Content:"公司成立拥有专业的研发团队多人20人",Year:"2016年8月"},
    {Content:"深圳宇飞智能科技有限公司拥有三家生产厂总部设在深圳",Year:"2017年6月"}];
    
      this.courseList.push(img2);
    
    
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>